import { gql } from 'graphql-request'

export const CHECK_IS_FOLLOWED_USER = gql`
  query CheckIsFollowedUser($userId: Float!) {
    checkIsFollowedUser(userId: $userId)
  }
`
